import { render, staticRenderFns } from "./BlocList.vue?vue&type=template&id=5ac6b4e3&"
import script from "./BlocList.vue?vue&type=script&lang=js&"
export * from "./BlocList.vue?vue&type=script&lang=js&"
import style0 from "./BlocList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports